



























































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "../models/account";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action } from "vuex-class";
import AddressHelpers, { Address } from "../models/address";
import countries from "@/helpers/CountryCodes.js";

import { NSLog } from "@/helpers/log";
const log = NSLog("components/AddressForm");

@Component({
  components: {
    loader
  }
})
export default class AddressForm extends Vue {
  get countries() {
    return countries;
  }

  get addressComponents() {
    return {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      administrative_area_level_1: "short_name",
      administrative_area_level_2: "short_name",
      // country: "long_name",
      postal_code: "short_name",

      sublocality: "long_name",
      sublocality_level_1: "long_name",
      sublocality_level_2: "long_name",
      country: "short_name",
      postal_code_prefix: "short_name",
      premise: "long_name"
    };
  }
  @Prop() public address?: Address;

  public loading = false;
  private valid: boolean = false;
  private add: Address = AddressHelpers.New();

  @Watch("valid") public WatchValid(v: boolean) {
    this.$emit("input", v);
  }

  @Watch("add", { deep: true }) public addWatch() {
    this.$emit("address", this.add);
  }

  public created() {
    if (this.address) {
      this.add = AddressHelpers.Copy(this.address);
    }
  }

  public setAddressData(data: any) {
    log("data:", data);
    if (!data) {
      return;
    }
    this.add = {
      type: "street",
      pickup: false,
      line1: data.name || (data.street_number || "") + " " + (data.route || ""),
      city: data.locality || "",
      region: data.administrative_area_level_1,
      suburb: data.sublocality_level_1 || data.locality || "",
      postal_code: data.postal_code || data.postal_code_prefix || "",
      country: data.country || "",
      // complex: "",
      validated: false,

      lat: data.latitude || 0,
      long: data.longitude || 0
    };
  }

  // workaround for chrome, please don't AUTOFILLLLLLL :(
  private randName() {
    let result = "";
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charsLen = chars.length;
    for (let i = 0; i < 20; i++) {
      result += chars.charAt(Math.floor(Math.random() * charsLen));
    }
    return result;
  }
}
